<script>
  import { createEventDispatcher } from "svelte"

  import Typetester from "./components"

  export let attributes
  export let action
  export let backgroundColor

  const dispatch = createEventDispatcher()
  let moreThanOneAttribute = attributes.length > 1

  $: disabled =
    action === "deselect" && attributes.filter((a) => a.selected).length === 1

  function attributeFilter(attribute) {
    if (action === "select") {
      return !attribute.selected
    } else {
      return attribute.selected
    }
  }

  function onToggle(event) {
    const attribute = event.detail.attribute
    const index = attributes.findIndex((w) => w.name === attribute.name)
    if (~index) attributes[index] = attribute
    dispatch("toggle", event)
  }
</script>

{#if moreThanOneAttribute}
  <div>
    {#each attributes.filter(attributeFilter) as attribute (attribute.name)}
      <Typetester.AttributeToggle
        {attribute}
        {disabled}
        {backgroundColor}
        on:toggle={onToggle}
      />
    {/each}
  </div>
{/if}

<style>
  div {
    display: flex;
    flex-wrap: nowrap;
    margin-left: var(--button-spacing);
  }

  div:empty {
    display: none;
  }

  div > :global(* + *) {
    margin-left: var(--button-spacing);
  }
</style>
